import axios from "axios";
import { analytics } from "../communication";
var addressRoot = "/api/mp/capturesvcs/addresschecker/address";
import { TRACKING_NAMESPACE, trackingEvents } from "./schedulerService";
export function getAddressAutoSuggest(_a) {
    var address = _a.address, country = _a.country;
    return axios
        .post(addressRoot, { address: address, country: country })
        .then(function (_a) {
        var data = _a.data;
        if (Array.isArray(data) && !data.length) {
            analytics.track(TRACKING_NAMESPACE, trackingEvents.ADDRESS_NO_SUGGESTIONS, {
                address: address,
                country: country,
            });
        }
        return data;
    })
        .catch(function (error) {
        console.error(error);
    });
}
